import {configure, start, done} from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

import router from "./router";
import {getToken} from "./utils/auth"; // get token from cookie
import getPageTitle from "./utils/get-page-title";
import {ElMessage, ElMessageBox} from "element-plus";
import {i18n, loadLanguageAsync} from "@/lang";

configure({showSpinner: false}); // NProgress Configuration

const whiteList = ["/login", "/register", "/companyRegister", "/forgetPassword", "/guide", "/settingguide", '/cloud/download', '/cloud/info']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    console.log(to, from, next, '=====')
    if ((from.path === "/email/customer/create" || from.path === "/email/write_mail") && to.path !== "/success" && to.path !== "/email/customer/list" && to.path !== "/email/examine") {
        if (to.path !== "/login" && to.path !== "/email/draft") {
            const confirmed = await confirmLeave();
            if (confirmed) {
                next();
            } else {
                next(false);
            }
        } else {
            next()
        }
    } else {
        // checkLoginTime();
        cancelAxiosRequests();
        startProgressBar();
        start();
        const hasToken = getToken();
        if (hasToken) {
            // 设置 page 页面 title
            if (to.meta?.title) {
                setPageTitle(i18n.global.t(to.meta?.title));
            }
            if (to.path === "/login") {
                next({path: "/"});
            } else {
                next();
            }
        } else {
            const isWhiteListed = whiteList.includes(to.path);
            const isDownloadPath = to.path.startsWith("/cloud/download/");
            const isDownloadInfo = to.path.startsWith("/cloud/info")
            if (isWhiteListed || isDownloadPath || isDownloadInfo) {
                console.log("未登录，放行", to.path);

                if (isDownloadPath) {
                    // 提取 key，例如 /cloud/download/abc123
                    const key = to.path.substring("/cloud/download/".length);
                    if (key) {
                        localStorage.setItem("key", key);
                    }
                }

                next();
            } else {
                console.log("未登录，跳转登录", to.path);
                next("/login");
            }
        }
    }

    // routerLoading ? glo_loading.loadingHide() : ''//关闭loading层

});

async function confirmLeave() {
    return ElMessageBox.confirm(i18n.global.t('system.permission.des'), i18n.global.t('sys.team.info'), {
        confirmButtonText: i18n.global.t('common.confirm'),
        cancelButtonText: i18n.global.t('common.cancel'),
        customClass: 'custom-confirm-box'
    })
        .then(() => true)
        .catch(() => false);
}

function cancelAxiosRequests() {
    if (Array.isArray(window.axiosCancelTokenList)) {
        window.axiosCancelTokenList.forEach((e) => e("cancel request"));
        window.axiosCancelTokenList = [];
    }
}

function startProgressBar() {
    // Your logic for starting progress bar
}

function setPageTitle(title) {
    document.title = getPageTitle(title);
}

router.afterEach((to, from, next) => {
    done();
});
